<template>
  <div>
    <!-- 검색 -->
    <search-nav>
      <search-year v-model="nav.year" :options="{
        default: new Date().getFullYear(),
      }" @input="onClickSearch"/>
    </search-nav>

    <!-- 1차 필터 -->
    <vs-tabs v-model="select점검구분Index">
      <vs-tab v-for="ri in 점검구분" :label="ri" @click="onClickSearch"/>
    </vs-tabs>

    <!-- 목록 -->
    <vx-card>
      <div class="flex">
        <vs-select v-model="nav.perPage" @input="onClickSearch" autocomplete>
          <vs-select-item v-for="(item, index) in [50, 75, 100, 125, 150, 300]" :key="index" :value="item" :text="`${item}개씩 보기`" />
        </vs-select>

        <div class="ml-auto">
          <search-keyword label="" v-model="nav.keyword" @input="onKeywordInput"/>
        </div>
      </div>

      <div class="flex" style="margin-top: 14px;">
        <p class="my-auto" style="font-size: 18px; font-weight: 500">대상수 : <span style="font-weight: 400">{{ searchedFields.length }}개소</span></p>
        <p v-if="select점검구분Index > 1" class="my-auto" style="font-size: 14px; font-weight: 400; color: #696D71; margin-left: 8px;">※ 공중이용시설(옹벽 및 절토사면, 교량, 터널, 제방 제외) 및 원료제조물의 식품제조가공업, 소규모수도</p>
        <vs-button class="ml-auto" color="secondary" @click="onClickExcelDownload"> <feather-icon icon="DownloadIcon" style="width: 20px; height: 20px" class="align-bottom mr-1" />엑셀 다운로드</vs-button>
      </div>

      <div class="grid border-top border-left" style="margin-top: 14px; grid-template-columns: minmax(100px, 310fr) 468fr minmax(100px, 310fr) 468fr; font-size: 16px; text-align: center;">
        <span class="p-2 border-right border-bottom" style="background-color: #FAFAFA; font-weight: 700;">작성주기</span>
        <span class="p-2 border-right border-bottom">수시</span>
        <span class="p-2 border-right border-bottom" style="background-color: #FAFAFA; font-weight: 700;">작성 / 대상시설</span>
        <span class="p-2 border-right border-bottom">
          <i v-if="successFields.length > 0" class="dot success"/>
          <i v-else class="dot danger" />
          {{ successFields.length }} / {{ searchedFields.length }}
        </span>
      </div>

      <div style="margin-top: 14px; overflow-x: auto;">
        <table>
          <colgroup>
            <col width="50px"/>
            <col width="110px"/>
            <col width="100px"/>
            <col width="80px"/>
            <col width="100px"/>
            <col width="130px"/>
            <col width="150px"/>
            <col width="150px"/>
            <col width="80px"/>
            <col width="200px"/>
            <col width="100px"/>
            <col width="80px"/>
          </colgroup>
          <thead>
          <tr>
            <th>연번</th>
            <th>소관부서</th>
            <th>담당팀</th>
            <th>담당자</th>
            <th>구분</th>
            <th>시설구분</th>
            <th>시설명</th>
            <th>시설위치<br/>(사업장주소)</th>
            <th>관리방법</th>
            <th>면적(㎡), 형식, 연장,<br/>차로수, 높이 등</th>
            <th>비고</th>
            <th>작성여부</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in list" :key="index" @click="onClickRow(item)" style="cursor: pointer">
            <td>{{ item.orderByNumber }}</td>
            <td>{{ item.소관부서 }}</td>
            <td>{{ item.담당팀 }}</td>
            <td>{{ item.담당자 }}</td>
            <td>{{ item.구분 }}</td>
            <td>{{ item.시설구분 }}</td>
            <td>{{ item.시설물명 }}</td>
            <td>{{ item.시설위치 }}</td>
            <td>{{ item.관리방법 }}</td>
            <td>{{ item.면적형식연장등 }}</td>
            <td>{{ item.비고 }}</td>
            <td>
              <i v-if="item.작성여부 > 0" class="dot success"/>
              <i v-else class="dot danger"/>
              {{ item.작성여부 }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="w-full vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(nav.lastPage) ? nav.lastPage : 1"
            v-model="nav.currentPage" @change="onChangePage"></k-pagination>
        </div>
      </div>

    </vx-card>

    <popup-excel-download
      v-model="showExcelPopup"
      :list="excelList"
      title="시설물 내부 등록현황"
      :file-name="`${nav.year}년도 ${점검구분[select점검구분Index]}${nav.keyword ? ` (${nav.keyword})` : ''} - 시설물 내부 등록현황`"
    />

    <popup-post-select v-model="showPostsPopup" :title="`${popupFieldName} - 게시글 목록`" :board-id="popupBoardId" :post-ids="popupPostIds" @select="onClickPopupPost" />
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchYear from "@/views/list/components/SearchYear.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";
import * as DataUtil from "@/util/DataUtil";
import * as UIUtil from "@/util/UiUtil";
import KPagination from "@/components/kPagination/kPagination.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload";
import PopupPostSelect from "@/popup/PopupPostSelect";

export default {
  components: {PopupPostSelect, PopupExcelDownload, KPagination, SearchKeyword, SearchYear, SearchNav},
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
    codes() {
      return { ...this.공중이용시설Codes, ...this.원료제조물Codes };
    },
    successFields () {
      return this.searchedFields.filter((item) => {
        return item.작성여부 > 0;
      });
    },
    searchedFields () {
      const is정기점검 = this.select점검구분Index <= 1;
      const 공중이용시설Values = is정기점검
        ? Object.values(this.공중이용시설Codes)
        : Object.values(this.수시점검공중이용시설Codes);
      const 원료제조물Values = is정기점검
        ? Object.values(this.원료제조물Codes)
        : Object.values(this.수시점검원료제조물Codes);
      const allowedValues = [...공중이용시설Values, ...원료제조물Values];
      const tabFilteredData = this.fieldData.filter(data => {
        const meta = JSON.parse(data.meta);
        return allowedValues.includes(meta.field_type);
      });
      if (tabFilteredData.length > 0 ) {
        return tabFilteredData.map((data) => {
          const meta = JSON.parse(data.meta);
          const 종별 = (meta.facility_category && meta.facility_category.classification) || "기타";
          return {
            소관부서: meta.소관부서 || "-",
            담당팀: meta.담당팀 || "-",
            담당자: meta.담당주무관 || "-",
            구분: this.get시설분류(meta) || "-",
            시설구분: this.get시설구분(meta, 종별) || "-",
            시설물명: data.field_name,
            시설위치: data.address || "-",
            관리방법: meta.관리방법 || "-",
            면적형식연장등: this.get면적형식연장등(meta) || "-",
            비고: meta.remarks || "-",
            작성여부: data.작성여부 || 0,
            최근업데이트일: data.최근업데이트일 || null,
            orderByNumber: data.orderByNumber || 0,
          };
        }).filter((item) => {
          if (this.nav.keyword) {
            const keyword = this.nav.keyword.toLowerCase();
            if (item.시설물명.toLowerCase().indexOf(keyword) === -1 && item.소관부서.toLowerCase().indexOf(keyword) === -1) {
              return false;
            }
          }
          return true;
        });
      }
      return [];
    }
  },
  watch: {
    postList() {
      const fieldData = JSON.parse(JSON.stringify(this.fieldData));
      fieldData.forEach((item) => {
        const matchingPosts = this.postList.filter((post) => {
          if (!post.fields) return false;
          return post.fields.find((field) => `${field.id}` === `${item.id}`);
        });

        item.작성여부 = matchingPosts.length;
        item.posts = matchingPosts.map(p => ({
          id: p.id,
          boardId: p.boardId,
          label: ['시설물 내부', p.created_at ? p.created_at.substring(0, 10) : null].filter(Boolean).join(' '),
        }));

        if (matchingPosts.length > 0) {
          const dates = matchingPosts.map(p => p.created_at).filter(Boolean);
          const latest = dates.length > 0 ? dates.reduce((max, d) => d > max ? d : max) : null;
          item.최근업데이트일 = latest ? latest.substring(0, 10) : null;
        } else {
          item.최근업데이트일 = null;
        }
      });

      this.fieldData = fieldData;
      this.updateList();
    }
  },
  data () {
    return {
      excelList: [],
      showExcelPopup: false,
      showPostsPopup: false,
      popupBoardId: null,
      popupPostIds: [],
      popupFieldName: '',
      nav: {
        perPage: 300,
        currentPage: 1,
        lastPage: 0,
        year: "", // 초기화는 options.default 값으로 설정한다.
        keyword: "",
      },
      공중이용시설Codes: {
        '건축물': 'building',
        '교량': 'bridge',
        '도서관': 'library',
        '둘이상용도건축물': 'mixed-use-building',
        '박물관 및 미술관': 'museum',
        '복합시설': 'complex-facility',
        '상수도': 'water-supply',
        '실내공연장': 'indoor-auditorium',
        '실내체육시설': 'indoor-sports-facility',
        '어린이집': 'daycare',
        '업무시설': 'office',
        '옹벽': 'retaining-wall',
        '의료기관': 'medical',
        '절토사면': 'cutting-slope',
        '제방': 'dike',
        '청사': 'government-building',
        '터널': 'tunnel',
        '하수도': 'sewage-treatment',
        '항만(방파제)': 'port',
        '항만(부두)': 'port-dock'
      },
      // 해빙기/우수기/동절기/기타 탭은 교량/옹벽/절토사면/제방/터널을 집계 대상에서 제외한다.
      수시점검공중이용시설Codes: {
        '건축물': 'building',
        '도서관': 'library',
        '둘이상용도건축물': 'mixed-use-building',
        '박물관 및 미술관': 'museum',
        '복합시설': 'complex-facility',
        '상수도': 'water-supply',
        '실내공연장': 'indoor-auditorium',
        '실내체육시설': 'indoor-sports-facility',
        '어린이집': 'daycare',
        '업무시설': 'office',
        '의료기관': 'medical',
        '청사': 'government-building',
        '하수도': 'sewage-treatment',
        '항만(방파제)': 'port',
        '항만(부두)': 'port-dock'
      },
      원료제조물Codes: {
        '먹는물': 'drinking-water',
        '소규모수도': 'waterworks',
        '식품제조가공업': 'food-processing',
        '급식소': 'mass_feeding_facility',
        '승강기': 'lift',
        '어린이 놀이시설': 'kids-play-area',
      },
      // 내부 등록현황은 먹는물(약수터)을 실외 시설로 보고 수시점검(해빙기/우수기/동절기/기타) 집계에서 제외한다.
      수시점검원료제조물Codes: {
        '소규모수도': 'waterworks',
        '식품제조가공업': 'food-processing',
      },
      점검구분: ['상반기', '하반기', '해빙기', '우수기', '동절기', '기타'],
      select점검구분Index: 0,
      postList: [], // 169 목록
      fieldData: [], // 전체 점검대상시설명
      list: [], // 화면에 보이는 점검대상시설명
      orderByList: [], // 685/page 순서
    }
  },
  async created () {
    await this.loadOrderByAPI();
    await this.loadFieldList();
    await this.loadPostList();
  },
  methods: {
    async loadOrderByAPI() {
      const params = {
        page: 1,
        perPage: 1,
        projectId: this.$route.params.proj_id,
        boardId: 1096,
        conditions: [{ key: "body.boardId", operator: "=", value: "685/page" }],
      };
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", params);
      if (response.data.length > 0) {
        const body = JSON.parse(response.data[0].post_content).body;
        this.orderByList = body.orderByPostIds;
      }
    },

    async loadPostList() {

      const conditions = [];

      if (this.nav.year) {
        conditions.push({ key: 'body.점검연도', operator: '=', value: this.nav.year });
      }

      const selected = this.점검구분[this.select점검구분Index];
      if (selected === '상반기' || selected === '하반기') {
        conditions.push({ key: 'body.정기점검', operator: '=', value: selected });
      } else if (selected) {
        conditions.push({ key: 'body.수시점검', operator: '=', value: selected });
      }

      const items = await DataUtil.loadDefragmentation(this.$store, "board/LOAD_POST_LIST", {
        projectId: this.$route.params.proj_id,
        boardId: 169,
        page: 1,
        perPage: 100,
        conditions: conditions,
        withMeta: true,
      }, true);

      this.postList = items.map(item => {
        const body = item.postContents ? item.postContents.body : {};
        return { id: item.id, boardId: 169, ...body, created_at: item.created_at };
      });
    },

    async _loadFieldList(page, list) {
      const codes = Object.values(this.codes);
      const params = {
        page,
        perPage: 50,
        projectId: this.$route.params.proj_id,
        codes,
      };
      const _apiData = await this.$store.dispatch("project/LOAD_FIELD_LIST", params);
      list.push(..._apiData.data);
      if (_apiData && Number(_apiData.last_page) >= Number(page)) {
        await this._loadFieldList(page + 1, list);
      }
    },
    async loadFieldList() {
      UIUtil.loading(true)
      const data = [];
      await this._loadFieldList(1, data)
      const allValues = Object.values(this.codes);
      const filtered = data.filter(item => {
        const meta = JSON.parse(item.meta);
        return allValues.includes(meta.field_type);
      });
      filtered.forEach((item) => {
        const findIndex = this.orderByList.indexOf(item.id);
        item.orderByNumber = findIndex > -1 ? findIndex + 1 : 0;
      });
      this.fieldData = filtered;
      UIUtil.loading(false)

      this.updateList();
    },

    buildRowData(data) {
      const meta = JSON.parse(data.meta);
      const 종별 = (meta.facility_category && meta.facility_category.classification) || "기타";
      return {
        id: data.id,
        시설물명: data.field_name,
        소관부서: meta.소관부서 || "-",
        담당팀: meta.담당팀 || "-",
        담당자: meta.담당주무관 || "-",
        구분: this.get시설분류(meta) || "-",
        시설구분: this.get시설구분(meta, 종별) || "-",
        시설위치: data.address || "-",
        관리방법: meta.관리방법 || "-",
        면적형식연장등: this.get면적형식연장등(meta) || "-",
        비고: meta.remarks || "-",
        작성여부: data.작성여부 || 0,
        최근업데이트일: data.최근업데이트일 || null,
        orderByNumber: data.orderByNumber || 0,
        posts: data.posts || [],
      };
    },

    setTableFieldData(fieldData) {
      const is정기점검 = this.select점검구분Index <= 1;
      const 공중이용시설Values = is정기점검
        ? Object.values(this.공중이용시설Codes)
        : Object.values(this.수시점검공중이용시설Codes);
      const 원료제조물Values = is정기점검
        ? Object.values(this.원료제조물Codes)
        : Object.values(this.수시점검원료제조물Codes);
      const allowedValues = [...공중이용시설Values, ...원료제조물Values];
      const tabFiltered = fieldData.filter(data => {
        const meta = JSON.parse(data.meta);
        return allowedValues.includes(meta.field_type);
      });
      const list = tabFiltered.map((data) => {
        return this.buildRowData(data);
      }).filter((item) => {
        if (this.nav.keyword) {
          const keyword = this.nav.keyword.toLowerCase();
          if (item.시설물명.toLowerCase().indexOf(keyword) === -1 && item.소관부서.toLowerCase().indexOf(keyword) === -1) {
            return false;
          }
        }
        return true;
      }).sort( (a, b) => {
        // 685/page 순서 기준 정렬 (순서 미지정 항목은 뒤로)
        const orderA = a.orderByNumber || 0;
        const orderB = b.orderByNumber || 0;
        if (orderA !== orderB) {
          if (orderA === 0) return 1;
          if (orderB === 0) return -1;
          return orderA - orderB;
        }

        // 소관부서, 시설명 순으로 오름차순 정렬
        if (a.소관부서 < b.소관부서) return -1;
        if (a.소관부서 > b.소관부서) return 1;
        if (a.시설물명 < b.시설물명) return -1;
        if (a.시설물명 > b.시설물명) return 1;
        return 0;
      });

      const _total = Math.ceil(list.length / this.nav.perPage);
      this.nav.lastPage = _total < 1 ? 1 : _total;

      const perPage = this.nav.perPage;
      const currentPage = this.nav.currentPage;

      const start = (currentPage - 1) * perPage;
      const end = currentPage * perPage;

      return list.slice(start, end);
    },

    updateList() {
      this.list = this.setTableFieldData(this.fieldData);
    },

    onKeywordInput () {
      this.nav.currentPage = 1;
      this.updateList();
    },
    onClickSearch () {
      this.nav.currentPage = 1;
      this.loadPostList();
    },
    onClickExcelDownload () {
      this.excelList = this.searchedFields.sort((a, b) => {
        // 685/page 순서 기준 정렬 (순서 미지정 항목은 뒤로)
        const orderA = a.orderByNumber || 0;
        const orderB = b.orderByNumber || 0;
        if (orderA !== orderB) {
          if (orderA === 0) return 1;
          if (orderB === 0) return -1;
          return orderA - orderB;
        }

        // 소관부서, 시설명 순으로 오름차순 정렬
        if (a.소관부서 < b.소관부서) return -1;
        if (a.소관부서 > b.소관부서) return 1;
        if (a.시설물명 < b.시설물명) return -1;
        if (a.시설물명 > b.시설물명) return 1;
        return 0;
      }).map(({ orderByNumber, 최근업데이트일, ...rest }) => rest);
      this.showExcelPopup = true;
    },
    onChangePage(page) {
      this.nav.currentPage = page;
      this.updateList();
    },
    onClickRow(item) {
      if (item.작성여부 === 0) {
        // 시설물 내부(169) 등록현황 전용 페이지 - 신규작성은 항상 169로 이동한다.
        var resolvedWrite = this.$router.resolve({ name: 'write|tab', params: { proj_id: this.$route.params.proj_id, boardId: 169, pageType: 'write' }, query: { presetFieldId: item.id, presetYear: this.nav.year, presetPeriod: this.점검구분[this.select점검구분Index] } });
        window.open(resolvedWrite.href, '_blank');
        return;
      }
      if (item.posts.length === 1) {
        var resolved = this.$router.resolve({ name: 'write|update|tab', params: { proj_id: this.$route.params.proj_id, boardId: item.posts[0].boardId, pageType: 'write', postId: item.posts[0].id } });
        window.open(resolved.href, '_blank');
      } else {
        this.popupBoardId = item.posts[0].boardId;
        this.popupPostIds = item.posts
          .filter(function(p) { return p.boardId === item.posts[0].boardId; })
          .map(function(p) { return p.id; });
        this.popupFieldName = item.시설물명;
        this.showPostsPopup = true;
      }
    },
    onClickPopupPost(post) {
      var resolved = this.$router.resolve({ name: 'write|update|tab', params: { proj_id: this.$route.params.proj_id, boardId: post.boardId, pageType: 'write', postId: post.id } });
      window.open(resolved.href, '_blank');
    },
    getFieldTypeToString(type) {
      const keys = Object.keys(this.codes);
      for (const key of keys) {
        if (this.codes[key] === type) return key;
      }
    },
    get시설분류(meta) {
      const 공중이용시설Values = Object.values(this.공중이용시설Codes);
      const 원료제조물Values = Object.values(this.원료제조물Codes);
      if (공중이용시설Values.includes(meta.field_type)) return "공중이용시설";
      if (원료제조물Values.includes(meta.field_type)) return "원료·제조물";
      return "기타";
    },
    get시설구분(meta, 종별) {
      const fieldTypeName = this.getFieldTypeToString(meta.field_type);
      switch (fieldTypeName) {
        case "건축물": return "32-건축물";
        case "교량":
          if (meta.facility_category) {
            const classification = meta.facility_category.classification || "";
            if (meta.facility_category.cat2.includes("도로교량")) {
              if (classification === "1종") return "25-1종 교량";
              if (classification === "2종") return "25-2종 교량";
              if (classification === "3종") return "98-3종 교량";
            } else if (meta.facility_category.cat2.includes("철도")) {
              if (classification === "1종") return "26-1종 교량";
              if (classification === "2종") return "26-2종 교량";
              if (classification === "3종") return "100-3종 교량";
            }
          }
          return "교량";
        case "도서관": return "7-도서관";
        case "둘이상용도건축물": return "17-둘이상용도건축물";
        case "박물관 및 미술관": return "8-박물관 및 미술관";
        case "복합시설": return "17-복합시설";
        case "상수도": return "36-상수도";
        case "수도":
        case "소규모수도": return "89-수도법";
        case "실내체육시설": return "19-실내 체육시설";
        case "실내공연장": return "18-실내 공연장";
        case "어린이집": return "11-어린이 집";
        case "업무시설": return "16-업무시설";
        case "옹벽":
          if (종별 === "1종") return "38-1종 옹벽";
          if (종별 === "2종") return "38-2종 옹벽";
          if (종별 === "3종") return "38-3종 옹벽";
          return "38-옹벽";
        case "의료기관": return "9-의료기관";
        case "절토사면":
          if (종별 === "1종") return "38-1종 절토사면";
          if (종별 === "2종") return "38-2종 절토사면";
          if (종별 === "3종") return "38-3종 절토사면";
          return "38-절토사면";
        case "제방": return "34-제방";
        case "청사": return "16-청사";
        case "터널":
          if (meta.facility_category) {
            const classification = meta.facility_category.classification || "";
            if (meta.facility_category.cat2.includes("도로")) {
              if (classification === "1종") return "27-1종 터널";
              if (classification === "2종") return "27-2종 터널";
              if (classification === "3종") return "99-3종 터널";
            } else if (meta.facility_category.cat2.includes("철도")) {
              if (classification === "1종") return "28-1종 터널";
              if (classification === "2종") return "28-2종 터널";
              if (classification === "3종") return "101-3종 터널";
            }
          }
          return "터널";
        case "하수도": return "37-하수도";
        case "항만(방파제)": return "29-방파제";
        case "항만(부두)": return "30-부두";
        case "급식소": return "69-식품, 식품첨가물, 기구 및 용기포장(집단급식소)";
        case "먹는물": return "90-먹는물 관리법";
        case "승강기": return "85-승강기 안전관리법";
        case "식품제조가공업": return "69-식품제조가공업";
        case "어린이 놀이시설": return "84-어린이 놀이시설 안전관리법";
        default: return `${fieldTypeName} - ${종별}`;
      }
    },
    get면적형식연장등(meta) {
      let result = "";
      if (meta.건축_연면적) result += `건축 연면적: ${meta.건축_연면적}, `;
      if (meta.층수_최고높이) result += `층수-최고높이: ${meta.층수_최고높이}, `;
      if (meta.연장_길이) result += `연장-길이: ${meta.연장_길이}, `;
      if (meta.차로수_상행) result += `차로수-상행: ${meta.차로수_상행}, `;
      if (meta.차로수_하행) result += `차로수-하행: ${meta.차로수_하행}, `;
      if (meta.시설용량) result += `시설용량: ${meta.시설용량}, `;
      if (meta.경간형식) result += `경간형식: ${meta.경간형식}, `;
      if (meta.연장) result += `연장: ${meta.연장}, `;
      if (meta.높이) result += `높이: ${meta.높이}, `;
      if (meta.주요공법) result += `주요공법: ${meta.주요공법}, `;
      if (meta.일평균) result += `일평균: ${meta.일평균}, `;
      if (meta.제방연장) result += `제방연장: ${meta.제방연장}, `;
      if (meta.종류) result += `종류: ${meta.종류}, `;
      if (meta.허용월파량_호안) result += `허용월파량(호안): ${meta.허용월파량_호안}, `;
      if (meta.대표형식) result += `대표형식: ${meta.대표형식}, `;
      if (meta.일평균_식수인원) result += `일평균 식수인원: ${meta.일평균_식수인원}, `;
      const 기타_상세제원 = meta.기타_상세제원 || meta.otherSpecifications;
      if (기타_상세제원) result += `기타 상세제원: ${기타_상세제원}, `;
      result = result.slice(0, -2);
      return result.length === 0 ? "-" : result;
    },
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;

  border-top: solid 1px #cdcdcd;
  border-left: solid 1px #cdcdcd;

  &,
  th,
  td {
    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    font-size: 14px;
  }

  th {
    text-align: center;
    padding: 16px 6px;
    background: #FAFAFA;
    font-weight: 500;
  }

  td {
    padding: 6px;
    font-weight: 400;
  }

  tbody {
    tr:hover {
      background-color: #EDEDED;
    }
  }
}

</style>
